module.exports = __webpack_public_path__ + "img/IMGP8632b.d87a8a39.jpg";